import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import 'slick-carousel';
import 'magnific-popup';
import Splitting from 'splitting';

export default {
    links() {
        /** SKIP LINK NAVIGATION */
        $('#skip-to-content').click(function () {
            // strip the leading hash and declare
            // the content we're skipping to
            var skipTo = '#' + this.href.split('#')[1];
            // Setting 'tabindex' to -1 takes an element out of normal
            // tab flow but allows it to be focused via javascript
            $(skipTo)
                .attr('tabindex', -1)
                .on('blur focusout', function () {
                    // when focus leaves this element,
                    // remove the tabindex attribute
                    $(this).removeAttr('tabindex');
                })
                .focus(); // focus on the content container
        });
        /** END SKIP LINK NAVIGATION */

        /** ANIMATED ANCHOR LINKS **/
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            // Doesn't do it on page builder tabs
            if (!$(this).closest('li').hasClass('vc_tta-tab')) {
                if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                    if (
                        location.pathname.replace(/^\//, '') ===
                            this.pathname.replace(/^\//, '') &&
                        location.hostname === this.hostname
                    ) {
                        var target = $(this.hash);
                        var $this = this;
                        var header = $('header.header');
                        var wpAdminBar = $('#wpadminbar');
                        var fixedHeaderOffset =
                            parseInt(header.outerHeight()) -
                            parseInt(
                                header.css('padding-top').replace('px', '')
                            );
                        // If we're logged in and WP ADmin Bar exists, add it to the offset
                        if (wpAdminBar.length) {
                            fixedHeaderOffset += parseInt(
                                wpAdminBar.outerHeight()
                            );
                        }
                        target = target.length
                            ? target
                            : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate(
                                {
                                    scrollTop:
                                        target.offset().top - fixedHeaderOffset,
                                },
                                500,
                                function () {
                                    if (history.pushState) {
                                        history.pushState(
                                            null,
                                            null,
                                            $this.hash
                                        );
                                    } else {
                                        location.hash = $this.hash;
                                    }
                                }
                            );
                            e.preventDefault();
                        }
                    }
                }
            }
        });
        /** END ANIMATED ANCHOR LINKS **/

        /** Break link text to new line when link text is a URL **/
        $(document).ready(function () {
            $('a').each(function () {
                var $this = $(this);
                var innerLink = $this.text();
                if (innerLink.startsWith('http')) {
                    $this.css('word-break', 'break-all');
                }
            });
        });
        /** End Break link text to new line when link text is a URL **/
    },
    itemReveal() {
        // eslint-disable-next-line no-unused-vars
        // var $itemReveals = $('.reveal').waypoint({
        //   handler: function () {
        //     $(this)[0].element.classList.add('revealed');
        //   },
        //   offset: '85%',
        // });

        // Use gsap and ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);
        let reveals = gsap.utils.toArray('.reveal');
        reveals.forEach((reveal) => {
            if (!$(reveal).closest('.reveal-stagger-container').length) {
                ScrollTrigger.create({
                    trigger: reveal,
                    start: 'top 75%', // when the top of the element is 75% from the top of the viewport
                    toggleClass: 'revealed',
                    // toggleActions: 'play pause resume none',
                    once: true, // only trigger the toggle once. we can control repeat behavior using toggleActions
                });
            }
        });

        // Stagger reveals with a gsap.timeline() + ScrollTrigger
        let postStaggers = gsap.utils.toArray(
            '.reveal-stagger-container .visc-posts-list .row'
        );
        postStaggers.forEach((stagger) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: stagger,
                    start: 'top 75%',
                },
            });

            let children = stagger.children; // the immediate children elements of the current target
            tl.to(children, {
                duration: 0.5,
                y: 0,
                opacity: 1,
                stagger: 0.15,
            });
        });

        // Stagger reveals with a gsap.timeline() + ScrollTrigger
        let staggers = gsap.utils.toArray('.reveal-stagger-container');
        staggers.forEach((stagger) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: stagger,
                    start: 'top 75%',
                },
            });

            let children = stagger.querySelectorAll('.reveal'); // the immediate children elements of the current target
            tl.to(children, {
                duration: 0.5,
                y: 0,
                opacity: 1,
                stagger: 0.1,
            });
        });
    },
    slider() {
        let visceralSlider = $('.visceral-slider');

        if (visceralSlider) {
            visceralSlider.each(function () {
                let slider, slide;
                slider = $(this).find('> .elementor-widget-wrap');
                slide = '.visceral-slider > div > section';

                slider.slick({
                    slide: slide,
                    autoplay: false,
                    fade: true,
                    speed: 1200,
                    infinite: true,
                    cssEase: 'ease',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow: `<button type="button" class="slick-next btn--no-decoration"><span class="screen-reader-text">Next</span><svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.0762 24.9323V23.1823H28.6595L25.4928 19.974L26.7428 18.724L32.0762 24.0573L26.7428 29.3906L25.4928 28.1406L28.6595 24.9323H16.0762Z" fill="white"/>
                        <rect x="0.5" y="0.5" width="47.1519" height="47.114" rx="23.557" stroke="white"/>
                        </svg>
                        </button>`,
                    prevArrow: `<button type="button" class="slick-prev btn--no-decoration"><span class="screen-reader-text">Previous</span><svg width="50" height="49" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.0723 23.181V24.931L20.4889 24.931L23.6556 28.1393L22.4056 29.3893L17.0723 24.056L22.4056 18.7227L23.6556 19.9727L20.4889 23.181L33.0723 23.181Z" fill="white"/>
                        <rect x="48.6484" y="47.6133" width="47.1519" height="47.114" rx="23.557" transform="rotate(-180 48.6484 47.6133)" stroke="white"/>
                        </svg>
                        </button>`,
                });
            });
        }
    },
    magnificPopup() {
        let videoLink = $('.modal-link-video');
        if (videoLink) {
            videoLink.magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        }
    },
    masthead() {
        /** MASTHEAD PROGRESSIVE IMAGES **/
        var masthead = document.querySelector('.masthead__media'),
            placeholderOverlay = document.querySelector('.masthead__overlay');

        if (masthead && placeholderOverlay) {
            // Load full size image. When loaded, fade our placeholder add it as bg to masthead
            var img = new Image();
            img.src = masthead.dataset.imageSrc;
            img.onload = function () {
                placeholderOverlay.classList.add('fade-out');
                masthead.style.backgroundImage = 'url(' + img.src + ')';
            };
        }

        /** END MASTHEAD PROGRESSIVE IMAGES **/

        // Masthead Titles
        let mastheadTitle = document.querySelector('.masthead .page-title');

        // Get Italic words from title to apply italic style after Splitting.js runs
        let italicWordsArray = [];
        if (mastheadTitle !== null) {
            let italics = mastheadTitle.querySelectorAll('em');
            if (italics) {
                italics.forEach((italic) => {
                    let italicWords = italic.innerText.split(' ');
                    if (italicWords.length > 1) {
                        italicWords.forEach((word) => {
                            italicWordsArray.push(word);
                        });
                    } else {
                        italicWordsArray.push(italic.innerText);
                    }
                });
            }
        }

        let breadcrumb = document.querySelector('.masthead .breadcrumb');
        let splitTitle = Splitting({
            target: '.masthead .page-title',
            by: 'lines',
        });

        splitTitle.forEach((splitResult) => {
            const wrappedLines = splitResult.lines
                .map(
                    (wordsArr) => `
            <span class="line"><div class="words">
              ${wordsArr
                  .map(
                      (word) => `${word.outerHTML}<span class="whitespace"> 
             </span>`
                  )
                  .join('')}
            </div></span>`
                )
                .join('');
            splitResult.el.innerHTML = wrappedLines;
        });

        // Get all words from title and apply italic style if it originally was italicized before Splitting.js ran
        let mastheadTitleWords = $('.masthead .page-title .word');
        if (mastheadTitleWords !== null) {
            mastheadTitleWords.each(function () {
                if (italicWordsArray.includes($(this).html())) {
                    $(this).css('font-style', 'italic');
                }
            });
        }

        if (mastheadTitle !== null) {
            setTimeout(function () {
                mastheadTitle.classList.add('title-revealed');
                if (breadcrumb !== null) {
                    breadcrumb.classList.add('breadcrumb-revealed');
                }
            }, 600);
        }
    },
    mastheadFade() {
        let didScroll = false;
        let $masthead = $('.masthead');
        let $mastheadMedia = $('.masthead__media');
        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }

        if (window.pageYOffset >= $masthead.outerHeight()) {
            $mastheadMedia.css({
                opacity: 0,
            });
        }

        function scrollPage() {
            let sy = scrollY();
            didScroll = false;
            let $mastheadHeight = $masthead.outerHeight();
            if (window.pageYOffset <= $mastheadHeight) {
                $mastheadMedia.css({
                    opacity: 1 - sy / ($mastheadHeight * 0.5),
                });
            }
        }
        if ($mastheadMedia) {
            window.addEventListener(
                'scroll',
                function () {
                    // eslint-disable-line no-unused-vars
                    if (!didScroll) {
                        didScroll = true;
                        setTimeout(scrollPage, 100);
                    }
                },
                false
            );
        }
    },
    header() {
        /** FIXED HEADER ANIMATION **/
        var didScroll = false,
            scrollOffset = 100;

        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }

        function scrollPage() {
            var sy = scrollY();
            if (sy > scrollOffset) {
                $('.site-header--fixed').addClass(
                    'site-header--scroll-triggered'
                );
            } else {
                $('.site-header--fixed').removeClass(
                    'site-header--scroll-triggered'
                );
            }
            didScroll = false;
        }

        window.addEventListener('load', scrollPage);
        window.addEventListener(
            'scroll',
            function () {
                // eslint-disable-line no-unused-vars
                if (!didScroll) {
                    didScroll = true;
                    setTimeout(scrollPage, 100);
                }
            },
            false
        );
        /** END FIXED HEADER ANIMATION **/

        /**  SEARCH OVERLAY **/
        const searchIcon = document.querySelector('.site-header__search-icon');
        const siteSearch = document.querySelector('.site-search');
        const siteSearchClose = document.querySelector('.site-search__close');

        searchIcon.addEventListener('click', (e) => {
            e.preventDefault();
            siteSearch.classList.add('site-search--active');
            setTimeout(() => {
                $('.site-search__form input[type="text"]').focus();
            }, 500);
        });
        siteSearchClose.addEventListener('click', () => {
            siteSearch.classList.remove('site-search--active');
        });
        /**  END SEARCH OVERLAY **/

        // Mobile Icon
        $('.mobile-nav-icon').on('click', function () {
            $(this).toggleClass('mobile-nav-icon--active');
            $('.site-header').toggleClass('site-header--mobile-nav-active');
            $('body').toggleClass('mobile-nav-active');
        });

        // Disable click on mobile
        $('.mobile-menu__item--parent').on('click', function () {
            $(this).toggleClass('mobile-menu__item--opened');
        });
    },
    mainNavAccessibility() {
        let $mainNavigationTopLevelItemLinks = $(
            '.site-header .main-menu > .main-menu__item--parent > button'
        );

        if ($mainNavigationTopLevelItemLinks.length) {
            $mainNavigationTopLevelItemLinks.each(function () {
                $(this).prev('a').attr('aria-haspopup', 'true');
                $(this).on('click', function () {
                    $(this).closest('li').toggleClass('sub-menu-open');
                    $(this).attr('aria-expanded', 'true');
                });
            });
        }
    },
    mainNavMagicLine() {
        if ($(window).width() > 768) {
            let $mainNavigation = $('.site-header .main-menu');
            let $activeItem = $('.main-menu > .main-menu__item--active > a');

            if ($mainNavigation.length) {
                $mainNavigation.append('<div class="main-menu__line"></div>');

                let $mainNavigationItems = $('.site-header .main-menu > li');

                $mainNavigationItems.on('mouseenter', function () {
                    let width = $(this).find('a').outerWidth();
                    let postition = $(this).find('a').position().left;
                    $('.main-menu__line').css({
                        left: postition,
                        width: width,
                        opacity: 1,
                    });
                    $mainNavigation.addClass('main-menu--engaged');
                    $('.site-header').addClass('site-header--menu-engaged');
                });

                $('.site-header__search-icon').on('mouseenter', function () {
                    $('.site-header').addClass('site-header--menu-engaged');
                });

                $('.site-header__search-icon').on('mouseleave', function () {
                    $('.site-header').removeClass('site-header--menu-engaged');
                });

                $mainNavigationItems.on('mouseleave', function () {
                    let width = 0,
                        position = 0,
                        opacity = 0;

                    if ($activeItem.length) {
                        width = $activeItem
                            .find('.main-menu__link-wrapper')
                            .outerWidth();
                        position = $activeItem
                            .find('.main-menu__link-wrapper')
                            .position().left;
                        opacity = '1';
                        $('.main-menu__line').css({
                            left: position,
                            width: width,
                            opacity,
                        });
                    } else {
                        $('.main-menu__line').css({
                            opacity,
                        });
                    }

                    $('.site-header').removeClass('site-header--menu-engaged');
                });
            }

            let $secondaryNavigationItems = $(
                '.site-header .secondary-menu > li'
            );

            if ($secondaryNavigationItems) {
                $secondaryNavigationItems.on('mouseenter', function () {
                    $('.site-header').addClass('site-header--menu-engaged');
                });

                $secondaryNavigationItems.on('mouseleave', function () {
                    $('.site-header').removeClass('site-header--menu-engaged');
                });
            }
        }
    },
    subNavigation() {},
    subSubNavigation() {},
    anchorSubNavigation() {
        let $subNavigation = $('.visc-anchor-nav ul');
        if ($subNavigation.length) {
            $subNavigation.each(function () {
                $(this).append('<div class="visc-anchor-nav__line"></div>');

                let $subNavigationItems = $subNavigation.find('li');

                // Set first item to active on page load
                let $firstItem = $subNavigationItems.first();
                let width = $firstItem.outerWidth();
                let position = $firstItem.position().left;
                let subNavigationScrollLeft = $subNavigation.scrollLeft();

                $('.visc-anchor-nav__line').css({
                    left: position + subNavigationScrollLeft,
                    width: width,
                });
            });
        }

        // Store anchor links in array
        let anchorLinks = $('.visc-anchor-nav a')
            .map(function () {
                return this.href.substr(this.href.indexOf('#'));
            })
            .toArray();

        // Add click handler for anchor links
        $('.visc-anchor-nav a').on('click', function (e) {
            e.preventDefault();

            // Get the href attribute directly
            let href = $(this).attr('href');
            // If it's a full URL, extract just the hash part
            let targetId = href.includes('#') ? '#' + href.split('#')[1] : href;

            // Try to find the target element
            let $target = $(targetId);

            if ($target.length) {
                // Calculate offset accounting for fixed header
                let headerHeight = $('.site-header').outerHeight() || 100;
                let offset = $target.offset().top - headerHeight;

                // Smooth scroll to target
                $('html, body')
                    .stop()
                    .animate(
                        {
                            scrollTop: offset,
                        },
                        500,
                        function () {
                            // After animation completes, ensure the correct item is active
                            $('.visc-anchor-nav li').removeClass(
                                'active-anchor'
                            );
                            $(e.currentTarget)
                                .parent('li')
                                .addClass('active-anchor');
                        }
                    );

                // Update active state immediately for visual feedback
                $('.visc-anchor-nav li').removeClass('active-anchor');
                $(this).parent('li').addClass('active-anchor');

                // Update line position
                let $subNavigation = $('.visc-anchor-nav ul');
                let subNavigationScrollLeft = $subNavigation.scrollLeft();
                let width = $(this).parent('li').outerWidth();
                let position = $(this).parent('li').position().left;
                $('.visc-anchor-nav__line').css({
                    left: position + subNavigationScrollLeft,
                    width: width,
                    opacity: 1,
                });
            } else {
                console.warn('Target section not found:', targetId);
            }
        });

        function updateActiveSection() {
            if (!$subNavigation.length) return;

            let scrollTop = $(window).scrollTop();
            let activeState = '';

            // Find the current active section
            for (let i = 0; i < anchorLinks.length; i++) {
                let targetId = anchorLinks[i];
                let $target = $(targetId);

                if ($target.length) {
                    let anchorPos = $target.offset().top - 150; // Adjust threshold for activation
                    if (scrollTop >= anchorPos) {
                        activeState = targetId;
                    }
                }
            }

            // Update active state if we're past the header
            if (
                scrollTop >=
                $('.masthead').outerHeight() - $('.site-header').outerHeight()
            ) {
                let $activeSection = $('a[href="' + activeState + '"]');

                if (
                    $activeSection.length &&
                    !$activeSection.parent('li').hasClass('active-anchor')
                ) {
                    $('.visc-anchor-nav li').removeClass('active-anchor');
                    $activeSection.parent('li').addClass('active-anchor');

                    // Update line position
                    let subNavigationScrollLeft = $subNavigation.scrollLeft();
                    let width = $activeSection.parent('li').outerWidth();
                    let position = $activeSection.parent('li').position().left;

                    $('.visc-anchor-nav__line').css({
                        left: position + subNavigationScrollLeft,
                        width: width,
                        opacity: 1,
                    });
                }
            } else {
                // Reset to first item when at the top
                $('.visc-anchor-nav li').removeClass('active-anchor');
                $('.visc-anchor-nav li:first-child').addClass('active-anchor');
            }
        }

        // Handle scroll events with throttling
        let scrollTimeout;
        $(window).on('scroll', function () {
            if (scrollTimeout) {
                window.cancelAnimationFrame(scrollTimeout);
            }
            scrollTimeout = window.requestAnimationFrame(function () {
                updateActiveSection();
            });
        });

        // Update on page load
        $(window).on('load', updateActiveSection);

        // Handle horizontal scroll of navigation
        $subNavigation.on('scroll', function () {
            let $activeItem = $('.visc-anchor-nav li.active-anchor');
            if ($activeItem.length) {
                let subNavigationScrollLeft = $subNavigation.scrollLeft();
                let width = $activeItem.outerWidth();
                let position = $activeItem.position().left;

                $('.visc-anchor-nav__line').css({
                    left: position + subNavigationScrollLeft,
                    width: width,
                    opacity: 1,
                });
            }
        });
    },
    queryFilterLinks() {
        let $queryFilterLinks = $('.visc-query-filter__links');
        // $(document).on('ready', function () {

        // });

        if ($queryFilterLinks.length) {
            $queryFilterLinks.append(
                '<div class="visc-query-filter__line"></div>'
            );
            let $activeItem = $(
                '.visc-query-filter__links li.visc-query-filter-link--active'
            );

            if ($activeItem.length) {
                let width = $activeItem.outerWidth();
                let postition = $activeItem.position().left;
                let $queryFilterLinksScrollLeft =
                    $queryFilterLinks.scrollLeft();
                $('.visc-query-filter__line').css({
                    left: postition + $queryFilterLinksScrollLeft,
                    width: width,
                });
            }
            $queryFilterLinks.each(function () {
                let $queryFilterLinksItems = $queryFilterLinks.find('li');

                $queryFilterLinksItems.on('click', function () {
                    let width = $(this).outerWidth();
                    let postition = $(this).position().left;
                    let $queryFilterLinksScrollLeft =
                        $queryFilterLinks.scrollLeft();
                    $('.visc-query-filter__line').css({
                        left: postition + $queryFilterLinksScrollLeft,
                        width: width,
                    });
                });

                $queryFilterLinks.on('scroll', function () {
                    let width = $activeItem.outerWidth();
                    let postition = $activeItem.position().left;
                    $('.visc-query-filter__line').css({
                        left: postition,
                        width: width,
                        opacity: 1,
                    });
                });
            });
        }
    },
    ajaxLoadMore() {
        // AJAX Load More
        function visc_load_more() {
            // eslint-disable-next-line no-undef
            if (visceral_vars !== undefined) {
                var data = {
                    action: 'visc_load_more',
                    // eslint-disable-next-line no-undef
                    query: visceral_vars.query,
                    // eslint-disable-next-line no-undef
                    paged: visceral_vars.current_page,
                    // eslint-disable-next-line no-undef
                    security: visceral_vars.security,
                };

                var $button = $('.btn--load-more');

                $.ajax({
                    // eslint-disable-next-line no-undef
                    url: visceral_vars.ajaxurl, // AJAX handler
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                    },
                    complete: function () {
                        this.itemReveal();
                    },
                    success: function (data) {
                        $button.blur();
                        if (data) {
                            $button.find('span').text('Load More');

                            var $postsContainer = $(
                                '.posts-list-container > div'
                            );
                            $postsContainer.append(data);
                            // eslint-disable-next-line no-undef
                            visceral_vars.current_page++;
                            // eslint-disable-next-line no-undef
                            if (
                                // eslint-disable-next-line no-undef
                                visceral_vars.current_page ==
                                // eslint-disable-next-line no-undef
                                visceral_vars.max_page
                            ) {
                                $button.remove(); // if last page, remove the button
                            }
                        } else {
                            $button.remove(); // if last page, remove the button
                        }
                    },
                });
            }
        }

        $('.btn--load-more').on('click', function () {
            visc_load_more();
        });
    },
    socialShare() {
        /**  SOCIAL SHARE OVERLAY **/
        const shareLink = document.querySelector('.visc-social-share-btn');
        const socialShare = document.querySelector('.visc-social-share');
        const socialShareClose = document.querySelector(
            '.visc-social-share__close'
        );

        if (socialShare) {
            shareLink.addEventListener('click', () => {
                socialShare.classList.add('visc-social-share--active');
            });
            socialShareClose.addEventListener('click', () => {
                socialShare.classList.remove('visc-social-share--active');
            });
        }
        /**  END SOCIAL SHARE OVERLAY **/
    },

    buttonDecoration() {
        // Button decorations
        let $buttons = $(
            'button, input[type="button"], input[type="submit"], input[type="reset"], .btn, .elementor-button-link'
        );
        if ($buttons.length) {
            $buttons.each(function () {
                if (
                    !$(this).hasClass('btn--no-decoration') &&
                    !$(this).hasClass('btn--decorated') &&
                    !$(this).hasClass('main-menu__sub-menu-toggle') &&
                    !$(this).hasClass('mobile-menu__sub-menu-toggle') &&
                    !$(this).hasClass('add_list_item') &&
                    !$(this).hasClass('delete_list_item')
                ) {
                    $(this).addClass('btn--decorated');
                    $(this).wrapInner('<span></span>');
                    if ($(this).hasClass('visc-social-share-btn')) {
                        $(this).prepend(
                            `<svg class="btn__icon" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6667 15.5553C16.25 15.5553 15.855 15.6329 15.4818 15.7882C15.1085 15.9435 14.7743 16.1506 14.4792 16.4094L6.5625 11.8282C6.59722 11.7074 6.62326 11.5824 6.64062 11.4529C6.65799 11.3235 6.66667 11.1898 6.66667 11.0518C6.66667 10.9137 6.65799 10.78 6.64062 10.6506C6.62326 10.5212 6.59722 10.3961 6.5625 10.2753L14.401 5.74588C14.6962 6.02196 15.0391 6.23765 15.4297 6.39294C15.8203 6.54824 16.2326 6.62588 16.6667 6.62588C17.5868 6.62588 18.3724 6.30236 19.0234 5.65529C19.6745 5.00823 20 4.22746 20 3.31294C20 2.39843 19.6745 1.61765 19.0234 0.970588C18.3724 0.323527 17.5868 0 16.6667 0C15.7465 0 14.9609 0.323527 14.3099 0.970588C13.6589 1.61765 13.3333 2.39843 13.3333 3.31294C13.3333 3.45098 13.342 3.58471 13.3594 3.71412C13.3767 3.84353 13.4028 3.96863 13.4375 4.08941L5.59896 8.64471C5.30382 8.36863 4.96094 8.14863 4.57031 7.98471C4.17969 7.82078 3.76736 7.73882 3.33333 7.73882C2.41319 7.73882 1.62761 8.06235 0.976562 8.70941C0.325518 9.35647 0 10.1372 0 11.0518C0 11.9663 0.325518 12.7471 0.976562 13.3941C1.62761 14.0412 2.41319 14.3647 3.33333 14.3647C3.76736 14.3647 4.17969 14.2871 4.57031 14.1318C4.96094 13.9765 5.30382 13.7608 5.59896 13.4847L13.5156 18.0659C13.4809 18.1867 13.4592 18.3075 13.4505 18.4282C13.4418 18.549 13.4375 18.6698 13.4375 18.7906C13.4375 19.6706 13.75 20.4255 14.375 21.0553C15 21.6851 15.7639 22 16.6667 22C17.5695 22 18.3333 21.6851 18.9583 21.0553C19.5833 20.4255 19.8958 19.6706 19.8958 18.7906C19.8958 17.8933 19.5833 17.1298 18.9583 16.5C18.3333 15.8702 17.5695 15.5553 16.6667 15.5553Z" fill="white"/>
                            </svg>
                            `
                        );
                    } else {
                        $(this).prepend(
                            `<svg class="btn__icon" width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 8L0 0L4 4L0 8Z" fill="#0B7ED6"/>
                            </svg>
                            `
                        );
                    }
                }
            });
        }
    },

    hoverPromos() {
        let $promos = $('.visc-hover-promo');
        if ($promos.length) {
            $promos.each(function () {
                let $heading = $(this).find('.visc-hover-promo__heading');
                let $newHeading = $heading.clone();
                $newHeading.removeClass();
                $newHeading.addClass('visc-hover-promo__heading-initial');
                $(this)
                    .find('.visc-hover-promo__content')
                    .before($newHeading[0]);
                $(this).append(
                    `<svg class="visc-hover-promo__arrow-icon" width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.0762 24.9323V23.1823H28.6595L25.4928 19.974L26.7428 18.724L32.0762 24.0573L26.7428 29.3906L25.4928 28.1406L28.6595 24.9323H16.0762Z" fill="white"/>
                    <rect x="0.5" y="0.5" width="47.1519" height="47.114" rx="23.557" stroke="white"/>
                    </svg>`
                );
            });
        }
    },

    iframWrapper() {
        let $iframes = $('.post-content iframe');

        if ($iframes) {
            $iframes.each(function () {
                if (
                    $(this).attr('src').includes('youtu') ||
                    $(this).hasClass('ednamain')
                ) {
                    $(this).wrap('<div class="iframe-wrapper"></div>');
                }
            });
        }
    },
    customCheckBoxes() {
        let $checkboxes = $('label > input[type="checkbox"]');

        if ($checkboxes) {
            $checkboxes.each(function () {
                $(this).after('<span class="custom-checkbox"></span>');
            });
        }
    },

    elementorGallery() {
        function animateGalleryCaption() {
            let galleryFooter = $('.elementor-slideshow__footer');
            galleryFooter.css('opacity', 0);
            setTimeout(function () {
                galleryFooter.css('opacity', 1);
            }, 600);
        }
        $(document).on(
            'click',
            '.elementor-swiper-button',
            animateGalleryCaption
        );

        document.onkeydown = function (e) {
            if (e.key == 'ArrowLeft' || e.key == 'ArrowRight') {
                animateGalleryCaption();
            }
        };
    },
    init() {
        // JavaScript to be fired on all pages

        /** GLOBAL VARIABLES */
        // var body = document.querySelector('body');
        /** END GLOBAL VARIABLES */

        // Close elementor accordions by default
        $(window).on('elementor/frontend/init', function () {
            setTimeout(function () {
                $(':not(.elementor-tabs) .elementor-tab-title').removeClass(
                    'elementor-active'
                );
                $(':not(.elementor-tabs) .elementor-tab-content').css(
                    'display',
                    'none'
                );
            }, 300);
        });

        // Convert <em> strings to <em> elements in gallery lightboxes
        function convertEmStringToElement() {
            setTimeout(function () {
                let lightBoxTitle = $('.elementor-slideshow__title').html();
                if (lightBoxTitle !== undefined) {
                    lightBoxTitle = lightBoxTitle.replaceAll(
                        '&lt;em&gt;',
                        '<em>'
                    );
                    lightBoxTitle = lightBoxTitle.replaceAll(
                        '&lt;/em&gt;',
                        '</em>'
                    );
                    lightBoxTitle = $.parseHTML(lightBoxTitle);
                    $('.elementor-slideshow__title').html(lightBoxTitle);

                    let lightBoxDescription = $(
                        '.elementor-slideshow__description'
                    ).html();
                    lightBoxDescription = lightBoxDescription.replaceAll(
                        '&lt;em&gt;',
                        '<em>'
                    );
                    lightBoxDescription = lightBoxDescription.replaceAll(
                        '&lt;/em&gt;',
                        '</em>'
                    );
                    lightBoxDescription = $.parseHTML(lightBoxDescription);
                    $('.elementor-slideshow__description').html(
                        lightBoxDescription
                    );
                }
            }, 500);
        }
        $(document).on(
            'click',
            '.elementor-gallery-item, .elementor-swiper-button',
            convertEmStringToElement
        );

        $(document).on('keydown', convertEmStringToElement);

        let gFormLabels = $('.gfield_label');

        if (gFormLabels.length) {
            gFormLabels.each(function () {
                let labelText = $(this).html();
                labelText = labelText.replaceAll('&lt;em&gt;', '<em>');
                labelText = labelText.replaceAll('&lt;/em&gt;', '</em>');

                labelText = $.parseHTML(labelText);

                $(this).html(labelText);
            });
        }

        // Misc. link behaviors
        this.links();

        // Global reveal animations (consider commenting out this and 'gsap' and 'ScrollTrigger' import if not in use)
        this.itemReveal();

        // Slider (consider commenting out this and 'slick-carousel' import if not in use)
        this.slider();

        // Modals (consider commenting out this and 'magnific-popup' import if not in use)
        this.magnificPopup();

        // Masthead
        this.masthead();

        this.mastheadFade();

        // Header
        this.header();

        // Main Nav Accessibility
        this.mainNavAccessibility();

        this.mainNavMagicLine();

        this.subNavigation();

        this.subSubNavigation();

        this.anchorSubNavigation();

        this.queryFilterLinks();

        // Load more
        this.ajaxLoadMore();

        // Social share
        this.socialShare();

        this.buttonDecoration();

        this.hoverPromos();

        this.customCheckBoxes();

        this.iframWrapper();

        this.elementorGallery();

        $(document).on('visceralPosts:ajaxSuccess', () => {
            this.itemReveal();
        });

        $(document).on('visceralPage:ajaxSuccess', () => {
            this.itemReveal();

            this.buttonDecoration();

            this.hoverPromos();

            this.customCheckBoxes();

            this.iframWrapper();
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js